import * as XLSX from "xlsx";
import { ObjectUtils } from "primereact/utils";

// Arma un .xlsx a partir de filas ya calculadas en memoria (típicamente lo
// que una tabla ya tiene filtrado/buscado en pantalla) y lo descarga. No pasa
// por el backend: las columnas se resuelven del lado del cliente, así el
// archivo siempre coincide con lo que el usuario está viendo.
//
// columnas: [{ header, field }] o [{ header, value: (fila, indice) => texto }]
// `field` puede ser un path anidado ("norma.numero").
export function exportarExcel({ data, columnas, nombreArchivo = "datos" }) {
  // Se arma como matriz (y no como objetos por header) para que dos columnas
  // con el mismo header no se pisen entre sí.
  const filas = (data || []).map((fila, indice) =>
    columnas.map((col) =>
      col.value
        ? col.value(fila, indice)
        : ObjectUtils.resolveFieldData(fila, col.field)
    )
  );

  const hoja = XLSX.utils.aoa_to_sheet([
    columnas.map((col) => col.header),
    ...filas,
  ]);
  const libro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(libro, hoja, "Datos");
  XLSX.writeFile(libro, `${nombreArchivo}.xlsx`);
}
